// Коды телефонных номеров
itsoftApp.createModule("selectCountry", function() {

    itsoftApp.loadStyle("/assets/build/prod/intlTelInput.css");
    itsoftApp.loadScript("/assets/scripts/intlTelInput.min.js", function() {

    	//$(".phone-number").intlTelInput();

    	$(".phone-number").intlTelInput({
            autoFormat: true,
            autoHideDialCode: true,
            defaultCountry: "ru",
            //nationalMode: true,
            //numberType: "MOBILE",
            //onlyCountries: ['us', 'gb', 'ch', 'ca', 'do'],
            //preferredCountries: ['cn', 'jp'],
            //responsiveDropdown: true,
            utilsScript: "/assets/scripts/utils.js"
        });

    });

});
